import https from "./https";
import store from "@/store";

const branchApi = {
  getBranches(params) {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(`${organization}/liff/branches`, {
      params
    });
  },
  getSingleBranch(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(`${organization}/liff/branches/${branchId}`);
  },
  isFavorite(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(`${organization}/liff/branches/${branchId}/is-favorite`);
  },
  addFavorite(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/branches/${branchId}/favorite`);
  },
  removeFavorite(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.delete(`${organization}/liff/branches/${branchId}/favorite`);
  },
  isBooking(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(`${organization}/liff/branches/${branchId}/is-booking`);
  },
  bindCustomer(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/branches/${branchId}/bind-customer`);
  },
  createChatRoom(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/branches/${branchId}/chatroom`);
  },
  pushBranchInfo(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/branches/${branchId}/push-info`);
  },
};

export default branchApi
